import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';

const SecondaryNavList = withStyles(() => ({
  root: {
    paddingBottom: 0,
  },
}))(List);

export default SecondaryNavList;
